function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#line-description_svg__h1dzrlfpia)"
}, React.createElement("path", {
  d: "M8.5 16h8v2h-8v-2zm0-4h8v2h-8v-2zm6-10h-8c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18.5c1.1 0 2-.9 2-2V8l-6-6zm4 18h-12V4h7v5h5v11z",
  fill: "#039BE8"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "line-description_svg__h1dzrlfpia"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5)",
  d: "M0 0h24v24H0z"
})));

var SvgLineDescription = function SvgLineDescription(props) {
  return React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cg clip-path='url(%23h1dzrlfpia)'%3E %3Cpath d='M8.5 16h8v2h-8v-2zm0-4h8v2h-8v-2zm6-10h-8c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18.5c1.1 0 2-.9 2-2V8l-6-6zm4 18h-12V4h7v5h5v11z' fill='%23039BE8'/%3E %3C/g%3E %3Cdefs%3E %3CclipPath id='h1dzrlfpia'%3E %3Cpath fill='%23fff' transform='translate(.5)' d='M0 0h24v24H0z'/%3E %3C/clipPath%3E %3C/defs%3E %3C/svg%3E";
export { SvgLineDescription as ReactComponent };